import React, { useState } from 'react';
import style from './style.module.scss';
import Icon, { SectionIcons } from '../../assets/icons';
import SegmentIllustration from '../../assets/segment_1.svg';
import { PremiumBadge } from '@magoosh/lib/info_badges';
import { SegmentDetailProps } from './types';
import { pluralize } from 'utilities/pluralize';
import { SegmentSlice } from '../../organisms/segment_slice';
import { CustomizePracticeFormModal } from '../../organisms/customize_practice_form_modal';
import { paths } from 'config/path_helpers';
import { Wrapper } from '../../lib/wrapper';
import { PageCard } from '../../lib/page_card';
import { HeaderWithIllustration } from '../../lib/header_with_illustration';

export const SegmentDetail: React.FC<SegmentDetailProps> = (props) => {
  const {
    section,
    title,
    description,
    estimatedTimeMinutes,
    percentComplete,
    slices,
    isQuizMode,
    locked
  } = props;

  const [formModalState, setFormModalState] = useState({
    open: false,
    practiceBlocks: [],
    isQuizMode: isQuizMode
  });

  const toggleOpen = (practiceBlocks) => {
    setFormModalState({
      ...formModalState,
      open: !formModalState.open,
      practiceBlocks
    });
  };

  const iconType: SectionIcons = {
    Math: 'Calc',
    Verbal: 'Notebook',
    Writing: 'Pen'
  };

  return (
    <Wrapper>
      <div className="u-margin-V-m">
        <a href={paths.dashboard()}>
          <strong>Home</strong>
        </a>{' '}
        {'>'} <span>{title}</span>
      </div>
      <PageCard>
        <HeaderWithIllustration
          illustration={SegmentIllustration}
          illustrationAltText={'Segment Illustration'}
          icon={<Icon iconType={iconType[section]} fill={style.iconSecondary} />}>
          <h2 className="u-margin-A-n">
            <strong>{title}</strong>
          </h2>
          <p>
            <span>
              {locked && <PremiumBadge className={'u-margin-R-xs'} />}
              Estimated Time <strong>{pluralize(estimatedTimeMinutes, 'Minute')}</strong>
            </span>
            {percentComplete && <span className="u-margin-R-xs">{percentComplete}% Complete</span>}
          </p>
          <p>{description}</p>
        </HeaderWithIllustration>
        {slices.map((sliceProps, index) => {
          return (
            <SegmentSlice
              key={sliceProps.title}
              number={index + 1}
              {...sliceProps}
              openModal={toggleOpen}
              segmentIsLocked={locked}
            />
          );
        })}
      </PageCard>
      <CustomizePracticeFormModal {...formModalState} toggleOpen={toggleOpen} />
    </Wrapper>
  );
};

export default SegmentDetail;
